import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useTheme } from '../providers/DialectThemeProvider';
const OutlinedInput = ({ value, onChange, placeholder, rightAdornment, type = 'text', ...props }) => {
    const { textStyles, outlinedInput } = useTheme();
    return (_jsxs("div", { className: clsx('dt-flex dt-items-center', outlinedInput), children: [_jsx("input", { className: clsx('dt-w-full dt-bg-transparent dt-outline-0', textStyles.input), autoComplete: "off", placeholder: placeholder, type: type, value: value, onChange: onChange, ...props }), rightAdornment && (_jsx("div", { className: "dt-flex dt-gap-1 dt-pl-2", children: rightAdornment }))] }));
};
export default OutlinedInput;
//# sourceMappingURL=OutlinedInput.js.map